'use strict';
var React = require('react');
var Border = require('../common/Border');
var appTypes = require('../../types/appTypes');
var assetsHelper =require('../../helper/assetsHelper');
var styleHelper =require('../../helper/styleHelper');
var propConst = require('../../constants/propConst');

/*
 * 进度条组件
 */
var ProgressBar = React.createClass({

  render: function () {
    var isBar = styleHelper.getPropertyValue(this.props, propConst.BAR_STYLE) === appTypes.ProgressBarStyle.BAR;

    var indicatorStyle;
    var trackBackgroundStyle;
    var progress = parseInt(styleHelper.getInt(this.props, propConst.PROGRESS), 10);
    var stripeStyle;
    var bgStyle = styleHelper.StyleUtil(this.props).size().border().style;

    indicatorStyle = {
      width: styleHelper.getWidth(this.props) * (progress / 100),
      backgroundColor: styleHelper.getPropertyValue(this.props, propConst.INDICATOR_COLOR)
    };

    trackBackgroundStyle = {
      backgroundColor: styleHelper.getPropertyValue(this.props, propConst.TRACK_COLOR)
    };

    stripeStyle = {
      backgroundImage: 'url(' + assetsHelper.getComponentAsset('progressThumb') + ')',
      backgroundColor : trackBackgroundStyle.backgroundColor
    };

    //bgStyle.backgroundColor = this.props.trackColor;
    return (<div style={bgStyle}>
      {
        isBar ?
          <div className="track" style={trackBackgroundStyle}>
            <div className="indicator" style={indicatorStyle}></div>
          </div>
          :
          <div className="stripe" style={stripeStyle}></div>
      }
    </div>);
  }

});

module.exports = ProgressBar;



// WEBPACK FOOTER //
// ./src/views/Components/ProgressBar.jsx